import clsx from 'clsx';
import { type ReactNode } from 'react';
import { fontSize, FontSize, type FontSizeType } from '../../../../constants/FontSize';
import styles from './index.module.scss';

type Props = {
  title?: string;
  className?: string;
  children?: ReactNode;
  variant?: 'normal' | 'border';
  fontSize?: FontSizeType;
  align?: 'left' | 'center';
  /** ページの主見出しに使う場合だけ 'h1' にする。見た目は変わらない */
  level?: 'h1' | 'h2';
};

const SectionTitle = ({
  title,
  className,
  children,
  variant = 'normal',
  fontSize: fontSizeProp = FontSize.LARGE,
  align = 'center',
  level = 'h2',
}: Props) => {
  const Heading = level;
  const headingClassName = clsx(
    styles.heading,
    fontSizeProp === FontSize.MEDIUM && styles['heading-medium-line-height'],
    align === 'left' && styles['heading-align-left'],
    className
  );

  return (
    <div>
      <Heading className={headingClassName} style={{ fontSize: fontSize(fontSizeProp) }}>
        {title ?? children}
      </Heading>
      {variant === 'border' ? (
        <div className={styles['circle-container']}>
          <div className={clsx(styles.circle, styles['circle-yellow'])} />
          <div className={clsx(styles.circle, styles['circle-blue'])} />
          <div className={clsx(styles.circle, styles['circle-orange'])} />
          <div className={clsx(styles.circle, styles['circle-green'])} />
          <div className={clsx(styles.circle, styles['circle-pink'])} />
        </div>
      ) : null}
    </div>
  );
};

export default SectionTitle;
